module.exports = require('./helpers/bundle-url').getBundleURL('cXHa9') + "resources/images/" + require('./helpers/bundle-manifest').resolve("6TNsU");